import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { ArrowUpCircle, ArrowDownCircle, CreditCard } from 'lucide-react';
import { Skeleton } from '../../components/ui/skeleton';

const Statement = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchStatement(); }, []);

  const fetchStatement = async () => {
    try {
      const response = await api.get('/me/statement');
      setTransactions(response.data || []);
    } catch (error) {
      console.error('Error fetching statement:', error);
    } finally { setLoading(false); }
  };

  const formatCurrency = (value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(value || 0));
  const formatDate = (dateString) => new Date(dateString).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  const isCredit = (tx) => Number(tx.signed_amount ?? (tx.direction === 'Credit' ? tx.amount : -tx.amount)) >= 0;
  const statusLabel = (status) => ({ Posted: 'Efetivada', Reversed: 'Estornada', Failed: 'Falhou', Processing: 'Processando', Pending: 'Pendente' }[status] || status);
  const statusVariant = (status) => status === 'Posted' ? 'default' : status === 'Failed' ? 'destructive' : 'secondary';

  if (loading) return <div className="space-y-8"><div><h1 className="text-4xl font-bold tracking-tight">Extrato</h1><p className="text-muted-foreground mt-2">Histórico de movimentações da sua conta</p></div><Card><CardContent className="space-y-4 pt-6">{[1,2,3,4,5].map((i) => <Skeleton key={i} className="h-16 w-full" />)}</CardContent></Card></div>;

  return <div className="space-y-8" data-testid="statement-page">
    <div><h1 className="text-4xl font-bold tracking-tight">Extrato</h1><p className="text-muted-foreground mt-2">Movimentações registradas diretamente no ledger da sua conta.</p></div>
    <Card className="border-border/50"><CardHeader><CardTitle>Movimentações recentes</CardTitle><CardDescription>Créditos e débitos efetivamente registrados na sua conta ItechPay.</CardDescription></CardHeader><CardContent>
      {transactions.length === 0 ? <div className="py-12 text-center"><p className="text-muted-foreground">Nenhuma movimentação encontrada.</p></div> : <div className="space-y-3">{transactions.map((tx) => {
        const credit = isCredit(tx);
        return <div key={`${tx.id}-${tx.journal_entry_id}`} className="flex items-center justify-between rounded-lg border border-border/50 p-4 transition-colors hover:bg-muted/50">
          <div className="flex items-center gap-4"><div className="flex h-10 w-10 items-center justify-center rounded-full bg-muted">{credit ? <ArrowUpCircle className="h-5 w-5" /> : <ArrowDownCircle className="h-5 w-5" />}</div><div><p className="font-medium">{tx.description}</p><p className="text-sm text-muted-foreground">{formatDate(tx.created_at)} · {tx.reference || tx.type}</p></div></div>
          <div className="space-y-1 text-right"><p className="text-lg font-bold font-mono">{credit ? '+' : '-'}{formatCurrency(tx.amount)}</p><Badge variant={statusVariant(tx.status)} className="text-xs">{statusLabel(tx.status)}</Badge></div>
        </div>;
      })}</div>}
    </CardContent></Card>
  </div>;
};

export default Statement;
